export default __webpack_public_path__ + "static/media/carxofes.b5ad4d14.jpg";